import { render, staticRenderFns } from "./DlgCustomerMemo.vue?vue&type=template&id=200bb987&scoped=true"
import script from "./DlgCustomerMemo.vue?vue&type=script&lang=js"
export * from "./DlgCustomerMemo.vue?vue&type=script&lang=js"
import style0 from "./DlgCustomerMemo.vue?vue&type=style&index=0&id=200bb987&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200bb987",
  null
  
)

export default component.exports